import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

const AccountPagination = ({ currentPage, totalPages, onPageChange }) => {
//   useEffect(() => {
//     if (data && data.length > 0) {
//       // BACKEND PAGINATION FIX → do not slice if data is already paginated
//       if (pageCount > 1 && data.length <= dataPerPage) {
//         setCurrentData(data);
//         return;
//       }

//       const endOffset = dataOffset + dataPerPage;
//       setCurrentData(data.slice(dataOffset, endOffset));

//       setPageCount(Math.ceil(data.length / dataPerPage));
//     }
//   }, [dataOffset, data, dataPerPage]); // <-- FIXED

//   const handlePageClick = (event) => {
//     const newOffset = event.selected * dataPerPage;
//     setDataOffset(newOffset);
//   };

  return (
    <nav
      aria-label="Page navigation example"
      className="nav-class d-flex justify-content-center py-5 example-pagination"
    >
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={(e) => onPageChange(e.selected + 1)}
        pageRangeDisplayed={5}
        pageCount={totalPages}
        forcePage={currentPage - 1}
        previousLabel="<"
        containerClassName="pagination"
        pageLinkClassName="page-num"
        previousLinkClassName="page-num"
        nextLinkClassName="page-num"
        activeClassName="active"
      />
    </nav>
  );
};

export default AccountPagination;